import React, { useState } from 'react';
import { FiShield, FiAlertCircle, FiLogOut } from 'react-icons/fi';
import { Button, Input } from '../../components/UI';
import { useAuth } from '../../context/AuthContext';
import styles from './TwoFactor.module.css';

const TwoFactor = () => {
  const { pendingUser, submit2FACode, cancel2FA } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) return;
    setLoading(true);
    setError('');
    try {
      await submit2FACode(code.trim());
    } catch (err) {
      setError(err.message || 'Invalid 2FA code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <FiShield />
          </div>
          <h1 className={styles.title}>Two-factor authentication</h1>
          <p className={styles.subtitle}>
            Enter the 6-digit code from your authenticator app
            {pendingUser?.email ? (
              <>
                <br />
                <span className={styles.email}>{pendingUser.email}</span>
              </>
            ) : null}
          </p>
        </div>

        {error && (
          <div className={styles.error}>
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className={styles.form}>
          <Input
            label="Authenticator code or recovery code"
            type="text"
            autoComplete="one-time-code"
            placeholder="123 456 or XXXX-XXXX"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/[^A-Za-z0-9 -]/g, '').toUpperCase())}
            autoFocus
            required
          />
          <Button type="submit" fullWidth loading={loading} disabled={code.replace(/\s|-/g, '').length < 6}>
            Verify
          </Button>
        </form>

        <button type="button" className={styles.cancel} onClick={cancel2FA}>
          <FiLogOut />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
};

export default TwoFactor;
